import { serverSideTranslations } from "next-i18next/serverSideTranslations"

import Privacy from "@app/USStocks/Register/pages/Privacy"
import { defaultLanguage } from "@config/i18n"
import { withNonAuthClient } from "@hoc/withNonAuth"

export const getStaticProps = async ({ locale }: { locale: string }) => ({
    props: {
        ...(await serverSideTranslations(locale || defaultLanguage, [
            "common",
            "components",
            "pages",
            "register",
            "login"
        ]))
    }
})

export default withNonAuthClient(Privacy)
